import * as React from "react";

import { useSelector, useDispatch } from "../../../../store";
import { toggleResumePage } from "../../../../store/slices/learner";
import { Box, Typography } from "@mui/material";

import RedirectButton from "../../../ui-components/Buttons/RedirectButton";

export default function MobileResumePage() {
	const learner = useSelector((state) => state.learner || {});
	const dispatch = useDispatch();

	const handleContinue = async () => {
		await dispatch(toggleResumePage());
	};
	return (
		<React.Fragment>
			<Box
				sx={{
					bgcolor: "white",
					height: "100%",
					width: { xs: "100%", sm: "calc(100% - 4px)" },
					p: 3,
					overflow: "auto",
					borderRadius: "18px 18px 0px 0px",
					textAlign: "center",
				}}
			>
				<Typography
					variant="h4"
					sx={{
						display: "flex",
						justifyContent: "center",
						mt: 1,
						color: "#06b6ad",
					}}
				>
					Welcome Back
				</Typography>
				<Typography
					variant="h3_bold"
					sx={{
						display: "flex",
						justifyContent: "center",
						mt: 2,
						color: "#06b6ad",
                        fontWeight: "bold"
					}}
				>
					{learner?.details?.name?.first}
				</Typography>
			

				<Box
					sx={{
						mt: 15,
					}}
				>
					<RedirectButton
						// url="/question"
						handleClick={handleContinue}
						removeSpacer={true}
						title="RESUME QUIZ"
					/>
				</Box>
			</Box>
		</React.Fragment>
	);
}
